<template>
  <div>
    <div id="credit-history-container">
      <iframe
        frameborder="0"
        width="100%"
        scrolling="no"
        :src="iframeSrc"
        allow="clipboard-read; clipboard-write"
        :height="height"
        @load="onIframeLoad"
      />
    </div>

    <ModalReceiptKreditKomed
      modal-id="modal-receipt-kredit-komed"
      :receipt="selectedReceipt"
    />
  </div>
</template>

<script>
import ModalReceiptKreditKomed from '@/views/pages/komed/components/ModalReceiptKreditKomed.vue'

export default {
  components: { ModalReceiptKreditKomed },
  data() {
    return {
      VUE_APP_BASE_AUTH_MODULE: process.env.VUE_APP_BASE_AUTH_MODULE,
      height: 600,
      selectedReceipt: {},
    }
  },
  computed: {
    iframeSrc() {
      return `${this.VUE_APP_BASE_AUTH_MODULE}/komed/content/credit-history`
    },
    iframeOrigin() {
      try {
        return new URL(this.VUE_APP_BASE_AUTH_MODULE).origin
      } catch {
        return this.VUE_APP_BASE_AUTH_MODULE
      }
    },
  },
  mounted() {
    window.addEventListener('message', this.watchIframe)
  },
  beforeDestroy() {
    this.cleanup()
  },
  unmounted() {
    this.cleanup()
  },
  methods: {
    cleanup() {
      window.removeEventListener('message', this.watchIframe)
    },
    onIframeLoad() {
      // Logic executed on iframe load if needed
    },
    watchIframe(event) {
      if (event.origin !== this.iframeOrigin) return

      const { type, data, route } = event.data || {}

      const handlers = {
        SET_DIMENSION: () => {
          this.height = Math.max(Math.floor(data?.height || 0), 600)
        },
        // Struk dirender host: modal `position: fixed` di dalam iframe ter-center
        // pada tinggi dokumen iframe (scrolling="no", height = tinggi konten),
        // jadi bisa jatuh jauh di luar layar user.
        OPEN_RECEIPT_MODAL: () => {
          this.selectedReceipt = data || {}
          this.$bvModal.show('modal-receipt-kredit-komed')
        },
      }

      if (handlers[type]) {
        handlers[type]()
      }

      if (route) {
        this.$router.push(route)
      }
    },
  },
}
</script>

<style scoped>
</style>
